"use client";

import { Phone, Mail } from "lucide-react";

interface AboutCTAProps {
    settings: any;
    ctaData?: {
        title?: string;
        subtitle?: string;
    };
}

export default function AboutCTA({ settings, ctaData }: AboutCTAProps) {
    // İletişim bilgileri doğrudan Settings'den gelir
    const phoneNumber = settings?.phoneNumber || "0850 850 XX XX";
    const email = settings?.contactEmail || "info@sigorta.com";

    // Başlık ve açıklama acentenin girdiği JSON verisinden gelir
    const title = ctaData?.title || "Hemen Sigorta Teklifi Alın";
    const subtitle = ctaData?.subtitle || "Size özel sigorta çözümlerimiz hakkında bilgi almak için hemen iletişime geçin";

    return (
        <section
            className="rounded-3xl mx-4 lg:mx-auto max-w-7xl p-12 text-white text-center shadow-xl transition-all duration-300"
            style={{
                background: `linear-gradient(to right, var(--color-primary), var(--color-secondary))`
            }}
        >
            <h2 className="text-3xl md:text-4xl font-bold mb-4">{title}</h2>
            <p className="mb-8 max-w-2xl mx-auto opacity-90">
                {subtitle}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
                {/* Telefon Butonu */}
                <button
                    className="px-8 py-4 bg-white rounded-xl font-semibold transition-all hover:scale-105 flex items-center justify-center shadow-md"
                    style={{ color: 'var(--color-primary)' }}
                    onClick={() => window.location.href = `tel:${phoneNumber.replace(/\D/g, '')}`}
                >
                    <Phone className="w-5 h-5 mr-2" /> {phoneNumber}
                </button>

                {/* E-posta Butonu */}
                <button
                    className="px-8 py-4 rounded-xl font-semibold transition-all hover:scale-105 flex items-center justify-center border border-white/20 shadow-md"
                    style={{
                        backgroundColor: 'color-mix(in srgb, var(--color-secondary), black 20%)'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'color-mix(in srgb, var(--color-secondary), black 30%)'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'color-mix(in srgb, var(--color-secondary), black 20%)'}
                    onClick={() => window.location.href = `mailto:${email}`}
                >
                    <Mail className="w-5 h-5 mr-2" /> E-posta Gönderin
                </button>
            </div>
        </section>
    );
}